var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserTrafficActive = function SvgUserTrafficActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#148DFD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.42 13.579a2.237 2.237 0 0 1 .476-3.524 2.21 2.21 0 0 1 2.208 0 2.238 2.238 0 0 1 .475 3.524M13.579 13.579a2.233 2.233 0 0 1-3.158 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#148DFD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.161 17.839c-3.024-3.537-2.87-8.857.475-12.203a9 9 0 0 1 12.728 0c3.346 3.346 3.5 8.667.475 12.203"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#148DFD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.66 15.339c-1.66-2.157-1.525-5.252.45-7.228a5.5 5.5 0 0 1 7.779 0c1.977 1.977 2.11 5.071.449 7.228"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#user-traffic-active_svg__a)",
    fillRule: "evenodd",
    stroke: "#148DFD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.99 20.013C8.505 18.276 10.095 17 12 17c1.905 0 3.495 1.276 4.01 3.013a8.958 8.958 0 0 1-8.02 0",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "user-traffic-active_svg__a",
    x1: 12,
    x2: 12,
    y1: 17,
    y2: 20.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6EDFF",
    stopOpacity: 0
  })))));
};
export { SvgUserTrafficActive as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYTc0OWRhOWVlNGJkN2VmNGMxMWZkYmJmOWYwM2IzNTMuc3ZnIjs=";